angular.module('aprima-core-ui').directive('apScrollableList', ['$timeout', function ($timeout) {
    'use strict';

    return {
        restrict: 'A',
        link: function (scope, $elem, attrs) {
            var elem = $elem[0];
            $elem.addClass('ap-scrollable');

            $timeout(function() {
                var listItemHeight = $elem.children(':last').outerHeight(true) || 40;
                var listItemWindowSize = scope.$eval(attrs.apScrollableList) || 5;
                $elem.css('max-height', listItemHeight * listItemWindowSize + 'px');
            });

            if(scope.$eval(attrs.scrollTopOnChange) && MutationObserver) {
                var observer = new MutationObserver(function() {
                    //if scrollTop is not 0, then scroll to the top of list
                    if(elem.scrollTop) {
                        $elem.scrollTop(0);
                    }
                });
                observer.observe(elem, { childList: true });

                scope.$on('$destroy', function () {
                    observer.disconnect();
                });
            }
        }
    };
}]);